var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBonusesBgNoActive(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 425,
    height: 166,
    viewBox: "0 0 425 166",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_119_128506)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 425,
    height: 166,
    rx: 12,
    fill: "#0B1014"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_119_128506)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M302.058 83.5077C302.058 73.8443 300.555 64.3956 297.548 55.5912L303.346 45.0689C298.622 33.6876 291.536 22.9505 282.302 13.7166C273.068 4.48267 262.331 -2.60381 250.949 -7.32812L240.427 -1.5301C231.623 -4.32174 222.389 -6.03967 212.511 -6.03967C202.632 -6.03967 193.399 -4.53648 184.594 -1.5301L174.072 -7.32812C162.69 -2.60381 151.953 4.48267 142.719 13.7166C133.486 22.9505 126.399 33.6876 121.675 45.0689L127.473 55.5912C124.681 64.3956 122.963 73.6295 122.963 83.5077C122.963 93.171 124.466 102.62 127.473 111.424L121.675 121.946C126.399 133.328 133.486 144.065 142.719 153.299C151.953 162.533 162.69 169.619 174.072 174.343L184.594 168.545C193.399 171.337 202.632 173.055 212.511 173.055C222.174 173.055 231.623 171.552 240.427 168.545L250.949 174.343C262.331 169.619 273.068 162.533 282.302 153.299C291.536 144.065 298.622 133.328 303.346 121.946L297.548 111.424C300.555 102.62 302.058 93.171 302.058 83.5077ZM125.111 83.5077C125.111 35.4055 164.408 -3.89226 212.511 -3.89226C260.613 -3.89226 299.911 35.4055 299.911 83.5077C299.911 131.61 260.613 170.908 212.511 170.908C164.194 170.908 125.111 131.61 125.111 83.5077Z",
    fill: "#13191F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.742 83.5064C119.742 74.4872 121.03 65.6828 123.393 57.3079L120.386 51.7246C116.95 61.6027 115.018 72.3398 115.018 83.5064C115.018 94.673 116.95 105.41 120.386 115.288L123.393 109.705C121.03 101.33 119.742 92.5255 119.742 83.5064Z",
    fill: "#13191F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.635 51.7246L301.629 57.3079C303.991 65.6828 305.28 74.2725 305.28 83.5064C305.28 92.7403 303.991 101.33 301.629 109.705L304.635 115.288C308.071 105.41 310.004 94.673 310.004 83.5064C310.004 72.3398 308.071 61.6027 304.635 51.7246Z",
    fill: "#13191F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.235 101.973H139.283C143.363 118.079 152.597 132.037 165.052 142.13L172.568 134.614C162.046 126.454 154.1 115.072 150.235 101.973Z",
    fill: "#13191F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.442 83.5056C147.442 72.339 150.234 61.8167 155.388 52.5828L147.657 44.8521C140.785 56.2334 136.92 69.3326 136.92 83.5056C136.92 86.2972 137.135 88.8741 137.349 91.451H147.872C147.657 88.8741 147.442 86.2972 147.442 83.5056Z",
    fill: "#13191F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.361 83.506C277.361 94.6726 274.57 105.195 269.416 114.429L277.147 122.16C284.018 110.778 287.884 97.679 287.884 83.506C287.884 80.7144 287.669 78.1374 287.454 75.5605H276.932C277.361 78.1374 277.361 80.7144 277.361 83.506Z",
    fill: "#13191F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.752 24.8804L252.451 32.1816C262.974 40.3418 270.919 51.7231 274.784 64.8223H285.736C281.656 48.9315 272.422 34.9732 259.752 24.8804Z",
    fill: "#13191F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.616 123.447C255.456 133.969 244.075 141.915 230.976 145.78V156.732C247.081 152.652 261.039 143.418 271.132 130.963L263.616 123.447Z",
    fill: "#13191F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.563 19.0827C207.14 18.6532 209.932 18.6532 212.509 18.6532C223.676 18.6532 234.198 21.4448 243.432 26.5987L251.162 18.8679C239.781 11.9962 226.682 8.13086 212.509 8.13086C209.717 8.13086 207.14 8.3456 204.563 8.56034V19.0827Z",
    fill: "#13191F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.454 147.928C217.878 148.358 215.086 148.358 212.509 148.358C201.342 148.358 190.82 145.566 181.586 140.412L173.855 148.143C185.237 155.015 198.336 158.88 212.509 158.88C215.301 158.88 217.878 158.665 220.454 158.45V147.928Z",
    fill: "#13191F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.186 43.5633C169.346 33.0409 180.727 25.0955 193.827 21.2302V10.2783C177.721 14.3584 163.763 23.5923 153.67 36.0473L161.186 43.5633Z",
    fill: "#13191F"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M210.79 -0.672363H209.287V0.83083H210.79V-0.672363Z",
    fill: "#13191F"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M210.575 1.26025H209.716V2.11922H210.575V1.26025Z",
    fill: "#13191F"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M210.36 2.76318H209.716V3.40741H210.36V2.76318Z",
    fill: "#13191F"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M213.365 -0.672363H211.862V0.83083H213.365V-0.672363Z",
    fill: "#13191F"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M212.935 1.26025H212.076V2.11922H212.935V1.26025Z",
    fill: "#13191F"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M212.72 2.76514H212.076V3.40936H212.72V2.76514Z",
    fill: "#13191F"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M215.732 -0.672363H214.229V0.83083H215.732V-0.672363Z",
    fill: "#13191F"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M215.301 1.26025H214.442V2.11922H215.301V1.26025Z",
    fill: "#13191F"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M215.087 2.76416H214.442V3.40839H215.087V2.76416Z",
    fill: "#13191F"
  }))), /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M182.152 4.9192L180.739 5.43359L181.254 6.846L182.666 6.3316L182.152 4.9192Z",
    fill: "#13191F"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M182.509 6.95256L181.702 7.24658L181.996 8.05367L182.803 7.75964L182.509 6.95256Z",
    fill: "#13191F"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M182.954 8.2494L182.349 8.46973L182.569 9.07511L183.174 8.85478L182.954 8.2494Z",
    fill: "#13191F"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M184.491 4.01686L183.078 4.53125L183.593 5.94365L185.005 5.42926L184.491 4.01686Z",
    fill: "#13191F"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M184.846 6.0503L184.039 6.34424L184.333 7.15133L185.14 6.85739L184.846 6.0503Z",
    fill: "#13191F"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M185.094 7.41718L184.488 7.6377L184.709 8.24301L185.314 8.02249L185.094 7.41718Z",
    fill: "#13191F"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M186.627 3.19132L185.215 3.70557L185.729 5.11812L187.142 4.60387L186.627 3.19132Z",
    fill: "#13191F"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M186.981 5.22691L186.174 5.52051L186.467 6.32776L187.275 6.03417L186.981 5.22691Z",
    fill: "#13191F"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M187.225 6.59266L186.619 6.81299L186.839 7.41837L187.445 7.19804L187.225 6.59266Z",
    fill: "#13191F"
  }))), /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M157.136 20.0582L155.984 21.0244L156.951 22.1759L158.102 21.2096L157.136 20.0582Z",
    fill: "#13191F"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M158.185 21.6606L157.527 22.2129L158.08 22.8708L158.738 22.3185L158.185 21.6606Z",
    fill: "#13191F"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M158.919 22.8491L158.426 23.2632L158.84 23.7568L159.333 23.3427L158.919 22.8491Z",
    fill: "#13191F"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M159.056 18.4752L157.904 19.4414L158.871 20.5929L160.022 19.6266L159.056 18.4752Z",
    fill: "#13191F"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M159.938 20.2171L159.28 20.769L159.832 21.4272L160.49 20.8752L159.938 20.2171Z",
    fill: "#13191F"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M160.676 21.4043L160.183 21.8184L160.597 22.312L161.09 21.8979L160.676 21.4043Z",
    fill: "#13191F"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M160.814 17.0312L159.662 17.9976L160.629 19.149L161.78 18.1826L160.814 17.0312Z",
    fill: "#13191F"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M161.694 18.7691L161.036 19.3213L161.588 19.9793L162.246 19.427L161.694 18.7691Z",
    fill: "#13191F"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M162.589 19.8194L162.096 20.2334L162.51 20.7269L163.003 20.3129L162.589 19.8194Z",
    fill: "#13191F"
  }))), /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M138.788 42.8546L138.036 44.1562L139.338 44.9081L140.09 43.6065L138.788 42.8546Z",
    fill: "#13191F"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M140.257 44.1525L139.827 44.8965L140.571 45.3259L141 44.5819L140.257 44.1525Z",
    fill: "#13191F"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M141.349 44.8601L141.027 45.418L141.585 45.7401L141.907 45.1822L141.349 44.8601Z",
    fill: "#13191F"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M139.942 40.6631L139.19 41.9648L140.492 42.7164L141.244 41.4147L139.942 40.6631Z",
    fill: "#13191F"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M141.407 41.9593L140.978 42.7031L141.721 43.1327L142.151 42.3889L141.407 41.9593Z",
    fill: "#13191F"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M142.691 42.7828L142.369 43.3408L142.927 43.6627L143.249 43.1047L142.691 42.7828Z",
    fill: "#13191F"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M141.178 38.7738L140.427 40.0757L141.729 40.8271L142.48 39.5252L141.178 38.7738Z",
    fill: "#13191F"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M142.643 40.0672L142.214 40.811L142.958 41.2405L143.387 40.4967L142.643 40.0672Z",
    fill: "#13191F"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M143.74 40.7819L143.418 41.3398L143.976 41.6619L144.298 41.1039L143.74 40.7819Z",
    fill: "#13191F"
  }))), /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M129.316 70.3868L129.055 71.8672L130.535 72.1283L130.796 70.6479L129.316 70.3868Z",
    fill: "#13191F"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M131.257 71.1088L131.107 71.9546L131.953 72.104L132.103 71.2582L131.257 71.1088Z",
    fill: "#13191F"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M132.506 71.558L132.395 72.1924L133.029 72.3042L133.141 71.6698L132.506 71.558Z",
    fill: "#13191F"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M129.7 68.027L129.439 69.5073L130.92 69.7681L131.181 68.2878L129.7 68.027Z",
    fill: "#13191F"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M131.649 68.7517L131.5 69.5977L132.346 69.7469L132.495 68.901L131.649 68.7517Z",
    fill: "#13191F"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M132.895 69.203L132.783 69.8374L133.418 69.9494L133.53 69.3149L132.895 69.203Z",
    fill: "#13191F"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M130.089 65.6691L129.828 67.1494L131.308 67.4102L131.569 65.9299L130.089 65.6691Z",
    fill: "#13191F"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M132.036 66.3948L131.887 67.2407L132.733 67.3898L132.882 66.5439L132.036 66.3948Z",
    fill: "#13191F"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M133.286 66.846L133.174 67.4805L133.808 67.5925L133.92 66.9581L133.286 66.846Z",
    fill: "#13191F"
  }))), /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M131.415 99.4706L129.935 99.7314L130.195 101.212L131.676 100.951L131.415 99.4706Z",
    fill: "#13191F"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M132.763 99.532L131.917 99.6812L132.066 100.527L132.912 100.378L132.763 99.532Z",
    fill: "#13191F"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M133.839 99.3617L133.204 99.4736L133.316 100.108L133.951 99.9961L133.839 99.3617Z",
    fill: "#13191F"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M130.984 97.1116L129.504 97.3726L129.765 98.8529L131.245 98.592L130.984 97.1116Z",
    fill: "#13191F"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M132.326 97.1793L131.48 97.3286L131.63 98.1745L132.476 98.0252L132.326 97.1793Z",
    fill: "#13191F"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M133.404 97.0018L132.77 97.1138L132.881 97.7482L133.516 97.6362L133.404 97.0018Z",
    fill: "#13191F"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M130.553 94.755L129.072 95.0161L129.333 96.4965L130.814 96.2354L130.553 94.755Z",
    fill: "#13191F"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M131.89 94.812L131.044 94.9614L131.193 95.8072L132.039 95.6578L131.89 94.812Z",
    fill: "#13191F"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M132.972 94.6382L132.338 94.75L132.45 95.3844L133.084 95.2726L132.972 94.6382Z",
    fill: "#13191F"
  }))), /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M141.563 126.223L140.261 126.974L141.012 128.276L142.314 127.525L141.563 126.223Z",
    fill: "#13191F"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M142.898 125.932L142.154 126.362L142.584 127.106L143.328 126.676L142.898 125.932Z",
    fill: "#13191F"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M143.99 125.313L143.432 125.635L143.754 126.193L144.312 125.871L143.99 125.313Z",
    fill: "#13191F"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M140.535 124.217L139.233 124.969L139.985 126.271L141.287 125.519L140.535 124.217Z",
    fill: "#13191F"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M141.757 123.73L141.014 124.16L141.443 124.903L142.187 124.474L141.757 123.73Z",
    fill: "#13191F"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M142.968 123.305L142.41 123.627L142.732 124.185L143.29 123.863L142.968 123.305Z",
    fill: "#13191F"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M139.213 122.129L137.911 122.881L138.663 124.183L139.964 123.431L139.213 122.129Z",
    fill: "#13191F"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M140.558 121.836L139.814 122.266L140.244 123.01L140.988 122.58L140.558 121.836Z",
    fill: "#13191F"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M141.636 121.223L141.078 121.545L141.4 122.103L141.958 121.781L141.636 121.223Z",
    fill: "#13191F"
  }))), /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M160.512 147.859L159.546 149.01L160.697 149.977L161.664 148.825L160.512 147.859Z",
    fill: "#13191F"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M161.647 147.186L161.095 147.844L161.753 148.396L162.305 147.738L161.647 147.186Z",
    fill: "#13191F"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M162.441 146.127L162.027 146.62L162.521 147.034L162.935 146.541L162.441 146.127Z",
    fill: "#13191F"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M158.759 146.274L157.793 147.425L158.944 148.392L159.911 147.24L158.759 146.274Z",
    fill: "#13191F"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M159.911 145.594L159.358 146.252L160.016 146.804L160.569 146.146L159.911 145.594Z",
    fill: "#13191F"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M160.57 144.696L160.156 145.189L160.65 145.604L161.064 145.11L160.57 144.696Z",
    fill: "#13191F"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M156.895 144.845L155.929 145.997L157.08 146.963L158.046 145.811L156.895 144.845Z",
    fill: "#13191F"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M158.01 143.878L157.458 144.536L158.116 145.088L158.668 144.43L158.01 143.878Z",
    fill: "#13191F"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M158.847 143.119L158.433 143.613L158.926 144.027L159.34 143.533L158.847 143.119Z",
    fill: "#13191F"
  }))), /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M185.831 161.787L185.317 163.199L186.73 163.713L187.244 162.301L185.831 161.787Z",
    fill: "#13191F"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M186.36 160.57L186.066 161.377L186.874 161.671L187.167 160.863L186.36 160.57Z",
    fill: "#13191F"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M186.893 159.611L186.673 160.216L187.278 160.436L187.499 159.831L186.893 159.611Z",
    fill: "#13191F"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M183.591 160.883L183.077 162.295L184.49 162.81L185.004 161.397L183.591 160.883Z",
    fill: "#13191F"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M184.326 159.731L184.032 160.539L184.839 160.832L185.133 160.025L184.326 159.731Z",
    fill: "#13191F"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M184.647 158.706L184.427 159.311L185.032 159.532L185.253 158.926L184.647 158.706Z",
    fill: "#13191F"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M181.273 160.181L180.759 161.594L182.171 162.108L182.686 160.695L181.273 160.181Z",
    fill: "#13191F"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M181.995 159.038L181.701 159.845L182.508 160.139L182.802 159.332L181.995 159.038Z",
    fill: "#13191F"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M182.603 157.876L182.383 158.481L182.988 158.702L183.209 158.097L182.603 157.876Z",
    fill: "#13191F"
  }))), /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M215.301 164.893H214.442V165.752H215.301V164.893Z",
    fill: "#13191F"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M215.087 163.604H214.442V164.248H215.087V163.604Z",
    fill: "#13191F"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M212.935 164.893H212.076V165.752H212.935V164.893Z",
    fill: "#13191F"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M212.72 163.604H212.076V164.248H212.72V163.604Z",
    fill: "#13191F"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M210.575 164.893H209.716V165.752H210.575V164.893Z",
    fill: "#13191F"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M210.36 163.604H209.716V164.248H210.36V163.604Z",
    fill: "#13191F"
  }))), /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M243.775 160.163L242.362 160.677L242.877 162.09L244.289 161.576L243.775 160.163Z",
    fill: "#13191F"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M242.827 159.008L242.02 159.301L242.313 160.108L243.12 159.815L242.827 159.008Z",
    fill: "#13191F"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M242.458 157.913L241.853 158.134L242.073 158.739L242.678 158.519L242.458 157.913Z",
    fill: "#13191F"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M241.433 161.06L240.021 161.574L240.535 162.986L241.947 162.472L241.433 161.06Z",
    fill: "#13191F"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M240.699 159.839L239.892 160.132L240.185 160.94L240.992 160.646L240.699 159.839Z",
    fill: "#13191F"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M240.054 158.62L239.448 158.84L239.669 159.446L240.274 159.225L240.054 158.62Z",
    fill: "#13191F"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M239.288 161.884L237.875 162.398L238.389 163.811L239.801 163.297L239.288 161.884Z",
    fill: "#13191F"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M238.478 160.478L237.671 160.772L237.965 161.579L238.772 161.285L238.478 160.478Z",
    fill: "#13191F"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M237.91 159.442L237.305 159.663L237.525 160.268L238.13 160.047L237.91 159.442Z",
    fill: "#13191F"
  }))), /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M268.082 144.808L266.931 145.774L267.897 146.926L269.048 145.96L268.082 144.808Z",
    fill: "#13191F"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M266.819 143.952L266.161 144.504L266.713 145.162L267.371 144.61L266.819 143.952Z",
    fill: "#13191F"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M266.058 143.054L265.564 143.468L265.979 143.961L266.472 143.547L266.058 143.054Z",
    fill: "#13191F"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M266.175 146.39L265.023 147.356L265.99 148.508L267.141 147.541L266.175 146.39Z",
    fill: "#13191F"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M265.204 145.559L264.546 146.111L265.098 146.769L265.756 146.217L265.204 145.559Z",
    fill: "#13191F"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M264.143 144.634L263.649 145.048L264.063 145.541L264.557 145.127L264.143 144.634Z",
    fill: "#13191F"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M264.407 147.839L263.256 148.805L264.222 149.957L265.374 148.991L264.407 147.839Z",
    fill: "#13191F"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M263.295 147.137L262.637 147.689L263.189 148.347L263.847 147.795L263.295 147.137Z",
    fill: "#13191F"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M262.383 146.088L261.89 146.502L262.304 146.996L262.797 146.582L262.383 146.088Z",
    fill: "#13191F"
  }))), /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M285.699 122.042L284.947 123.344L286.249 124.095L287.001 122.793L285.699 122.042Z",
    fill: "#13191F"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M284.353 121.814L283.924 122.558L284.668 122.988L285.097 122.244L284.353 121.814Z",
    fill: "#13191F"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M283.16 121.297L282.838 121.855L283.396 122.177L283.718 121.62L283.16 121.297Z",
    fill: "#13191F"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M284.541 124.25L283.789 125.552L285.091 126.304L285.843 125.002L284.541 124.25Z",
    fill: "#13191F"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M283.115 123.711L282.686 124.455L283.43 124.884L283.859 124.14L283.115 123.711Z",
    fill: "#13191F"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M282.111 123.291L281.789 123.849L282.347 124.171L282.669 123.613L282.111 123.291Z",
    fill: "#13191F"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M283.297 126.129L282.546 127.431L283.848 128.183L284.599 126.881L283.297 126.129Z",
    fill: "#13191F"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M281.962 125.894L281.533 126.638L282.277 127.067L282.706 126.323L281.962 125.894Z",
    fill: "#13191F"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M280.769 125.374L280.447 125.932L281.005 126.254L281.327 125.696L280.769 125.374Z",
    fill: "#13191F"
  }))), /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M294.5 94.8081L294.239 96.2886L295.72 96.5492L295.98 95.0687L294.5 94.8081Z",
    fill: "#13191F"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M293.056 94.8333L292.907 95.6792L293.753 95.8282L293.902 94.9823L293.056 94.8333Z",
    fill: "#13191F"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M291.755 94.806L291.643 95.4404L292.277 95.5525L292.389 94.918L291.755 94.806Z",
    fill: "#13191F"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M294.097 97.1681L293.836 98.6484L295.316 98.9095L295.577 97.4292L294.097 97.1681Z",
    fill: "#13191F"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M292.677 97.1961L292.528 98.042L293.374 98.1911L293.523 97.3452L292.677 97.1961Z",
    fill: "#13191F"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M291.347 97.1668L291.235 97.8013L291.87 97.913L291.982 97.2786L291.347 97.1668Z",
    fill: "#13191F"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M293.712 99.525L293.451 101.005L294.932 101.267L295.193 99.7863L293.712 99.525Z",
    fill: "#13191F"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M292.291 99.5559L292.142 100.402L292.988 100.551L293.137 99.7051L292.291 99.5559Z",
    fill: "#13191F"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M290.962 99.5267L290.851 100.161L291.485 100.273L291.597 99.6385L290.962 99.5267Z",
    fill: "#13191F"
  }))), /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M294.831 65.7973L293.351 66.0586L293.612 67.5389L295.092 67.2777L294.831 65.7973Z",
    fill: "#13191F"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M292.957 66.4783L292.111 66.6274L292.26 67.4734L293.106 67.3242L292.957 66.4783Z",
    fill: "#13191F"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M291.457 66.7202L290.822 66.832L290.934 67.4665L291.569 67.3546L291.457 66.7202Z",
    fill: "#13191F"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M295.263 68.15L293.782 68.4111L294.043 69.8915L295.524 69.6304L295.263 68.15Z",
    fill: "#13191F"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M293.391 68.8309L292.545 68.98L292.694 69.8259L293.54 69.6768L293.391 68.8309Z",
    fill: "#13191F"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M291.886 69.0787L291.252 69.1904L291.364 69.8249L291.998 69.7131L291.886 69.0787Z",
    fill: "#13191F"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M295.686 70.5113L294.206 70.772L294.467 72.2523L295.947 71.9917L295.686 70.5113Z",
    fill: "#13191F"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M293.825 71.1927L292.979 71.3418L293.129 72.1877L293.975 72.0386L293.825 71.1927Z",
    fill: "#13191F"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M292.331 71.4554L291.696 71.5674L291.808 72.2018L292.443 72.0898L292.331 71.4554Z",
    fill: "#13191F"
  }))), /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M284.011 38.7118L282.709 39.4634L283.461 40.7651L284.762 40.0135L284.011 38.7118Z",
    fill: "#13191F"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M282.263 39.9861L281.519 40.4155L281.948 41.1595L282.692 40.7301L282.263 39.9861Z",
    fill: "#13191F"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M280.983 40.7188L280.425 41.041L280.747 41.5988L281.305 41.2766L280.983 40.7188Z",
    fill: "#13191F"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M285.041 40.7162L283.739 41.4678L284.491 42.7695L285.793 42.0179L285.041 40.7162Z",
    fill: "#13191F"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M283.48 41.9017L282.736 42.3311L283.166 43.075L283.91 42.6456L283.48 41.9017Z",
    fill: "#13191F"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M282.311 42.7994L281.753 43.1216L282.075 43.6795L282.633 43.3573L282.311 42.7994Z",
    fill: "#13191F"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M286.363 42.8133L285.062 43.5649L285.813 44.8667L287.115 44.1151L286.363 42.8133Z",
    fill: "#13191F"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M284.613 44.0887L283.869 44.5181L284.299 45.262L285.042 44.8326L284.613 44.0887Z",
    fill: "#13191F"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M283.333 44.8101L282.775 45.1323L283.098 45.6902L283.655 45.3679L283.333 44.8101Z",
    fill: "#13191F"
  }))), /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M264.338 16.988L263.372 18.1396L264.524 19.1058L265.49 17.9541L264.338 16.988Z",
    fill: "#13191F"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M263.155 18.738L262.603 19.396L263.261 19.9482L263.813 19.2903L263.155 18.738Z",
    fill: "#13191F"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M262.338 19.8L261.924 20.2935L262.417 20.7076L262.831 20.2141L262.338 19.8Z",
    fill: "#13191F"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M266.081 18.581L265.115 19.7324L266.267 20.6987L267.233 19.5472L266.081 18.581Z",
    fill: "#13191F"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M265.033 20.1594L264.48 20.8174L265.138 21.3696L265.691 20.7116L265.033 20.1594Z",
    fill: "#13191F"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M264.081 21.3823L263.667 21.876L264.161 22.2899L264.575 21.7962L264.081 21.3823Z",
    fill: "#13191F"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M267.955 20.0038L266.988 21.1553L268.14 22.1215L269.106 20.9701L267.955 20.0038Z",
    fill: "#13191F"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M266.771 21.7462L266.219 22.4043L266.877 22.9564L267.429 22.2984L266.771 21.7462Z",
    fill: "#13191F"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M265.954 22.8122L265.54 23.3057L266.034 23.7198L266.448 23.2263L265.954 22.8122Z",
    fill: "#13191F"
  }))), /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M238.303 3.23784L237.789 4.65039L239.202 5.16463L239.716 3.75208L238.303 3.23784Z",
    fill: "#13191F"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M237.943 5.20797L237.649 6.01514L238.457 6.3089L238.75 5.50174L237.943 5.20797Z",
    fill: "#13191F"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M237.475 6.65244L237.255 7.25781L237.86 7.47807L238.081 6.8727L237.475 6.65244Z",
    fill: "#13191F"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M240.549 4.14961L240.034 5.56201L241.447 6.0764L241.961 4.664L240.549 4.14961Z",
    fill: "#13191F"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M240.193 6.11138L239.899 6.91846L240.707 7.21248L241.001 6.4054L240.193 6.11138Z",
    fill: "#13191F"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M239.727 7.55191L239.507 8.15723L240.112 8.37775L240.333 7.77243L239.727 7.55191Z",
    fill: "#13191F"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M242.869 4.84591L242.354 6.2583L243.767 6.77284L244.281 5.36045L242.869 4.84591Z",
    fill: "#13191F"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M242.44 7.01119L242.146 7.81836L242.954 8.11221L243.248 7.30504L242.44 7.01119Z",
    fill: "#13191F"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M242.041 8.25643L241.82 8.86182L242.426 9.08208L242.646 8.47669L242.041 8.25643Z",
    fill: "#13191F"
  }))), /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.3704,
    d: "M170.421 43.1348L168.489 41.2021C165.912 43.9938 163.55 47.0002 161.402 50.0066L163.765 51.5098C165.697 48.5034 168.059 45.7117 170.421 43.1348Z",
    fill: "#13191F"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2922,
    d: "M206.286 25.526L206.071 22.7344C202.206 23.1639 198.555 23.8081 194.904 24.8818L195.763 27.4587C199.199 26.5997 202.635 25.9555 206.286 25.526Z",
    fill: "#13191F"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2413,
    d: "M193.186 28.532L192.327 25.9551C188.677 27.2435 185.241 28.7467 182.02 30.6794L183.523 33.0416C186.314 31.3236 189.75 29.8204 193.186 28.532Z",
    fill: "#13191F"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3377,
    d: "M154.317 83.5064C154.317 82.2179 154.317 80.9295 154.532 79.641L151.525 79.4263C151.525 80.7147 151.311 82.2179 151.311 83.5064C151.311 85.8685 151.525 88.2307 151.74 90.5928L154.532 90.1634C154.317 88.0159 154.317 85.8685 154.317 83.5064Z",
    fill: "#13191F"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3655,
    d: "M162.262 53.8723L159.9 52.3691C157.967 55.5903 156.249 59.0261 154.961 62.6768L157.538 63.5357C159.041 60.3146 160.544 56.8787 162.262 53.8723Z",
    fill: "#13191F"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3084,
    d: "M154.963 92.9536L152.171 93.3831C152.815 97.0337 153.674 100.899 154.963 104.335L157.539 103.476C156.466 100.04 155.607 96.6042 154.963 92.9536Z",
    fill: "#13191F"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3631,
    d: "M156.893 66.3263L154.101 65.4673C153.028 69.1179 152.169 72.7685 151.739 76.6339L154.531 76.8486C154.96 73.198 155.819 69.7621 156.893 66.3263Z",
    fill: "#13191F"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3941,
    d: "M268.345 67.187L271.136 66.328C270.063 62.6774 268.774 59.2415 267.056 55.8057L264.479 57.0941C266.197 60.3152 267.486 63.7511 268.345 67.187Z",
    fill: "#13191F"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2488,
    d: "M263.19 54.7299L265.553 53.4414C263.62 50.2203 261.472 46.9992 259.11 44.2075L256.963 45.9255C259.325 48.7171 261.472 51.7235 263.19 54.7299Z",
    fill: "#13191F"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3483,
    d: "M270.706 80.5009L273.498 80.2862C273.283 76.4209 272.854 72.7702 271.995 69.1196L269.203 69.7639C270.062 73.4145 270.492 77.0651 270.706 80.5009Z",
    fill: "#13191F"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3022,
    d: "M246.442 32.8266C243.221 30.6791 240 28.9612 236.564 27.458L235.49 30.0349C238.711 31.5381 241.932 33.256 244.939 35.1887L246.442 32.8266Z",
    fill: "#13191F"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2369,
    d: "M233.987 26.3853C230.551 25.0968 226.685 24.0231 223.035 23.3789L222.391 26.1706C226.041 26.8148 229.477 27.6737 232.913 28.9622L233.987 26.3853Z",
    fill: "#13191F"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3913,
    d: "M255.246 43.994L257.394 42.0614C254.817 39.2697 252.025 36.6928 249.019 34.5454L247.301 36.6928C250.092 38.8402 252.669 41.2024 255.246 43.994Z",
    fill: "#13191F"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3453,
    d: "M180.943 34.5448L179.44 32.1826C176.219 34.33 173.213 36.6922 170.421 39.2691L172.354 41.2018C175.145 38.6249 177.937 36.4775 180.943 34.5448Z",
    fill: "#13191F"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3625,
    d: "M258.897 118.724L261.045 120.442C263.407 117.436 265.34 114.215 267.058 110.779L264.481 109.49C262.978 112.926 261.045 115.932 258.897 118.724Z",
    fill: "#13191F"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.319,
    d: "M249.447 128.602L251.165 130.749C254.172 128.387 256.748 125.596 259.325 122.804L257.178 121.086C254.816 123.663 252.239 126.24 249.447 128.602Z",
    fill: "#13191F"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2217,
    d: "M225.396 140.198L226.04 142.989C229.69 142.13 233.341 141.057 236.777 139.553L235.703 136.977C232.267 138.48 228.831 139.553 225.396 140.198Z",
    fill: "#13191F"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2014,
    d: "M238.066 135.903L239.355 138.48C242.791 136.762 246.012 134.829 249.018 132.467L247.3 130.32C244.294 132.253 241.288 134.185 238.066 135.903Z",
    fill: "#13191F"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.389,
    d: "M270.707 83.2909C270.707 87.1563 270.278 90.8069 269.634 94.2427L272.425 94.6722C273.07 91.0216 273.499 87.1563 273.499 83.2909V83.0762H270.707V83.2909Z",
    fill: "#13191F"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2537,
    d: "M265.769 107.128L268.345 108.202C269.849 104.766 271.137 101.115 271.996 97.4645L269.204 96.8203C268.345 100.471 267.272 103.907 265.769 107.128Z",
    fill: "#13191F"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3207,
    d: "M184.597 137.835C188.033 139.553 191.468 141.056 195.119 142.13L195.978 139.553C192.542 138.479 189.106 137.191 185.885 135.473L184.597 137.835Z",
    fill: "#13191F"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2266,
    d: "M172.786 129.891C175.578 132.253 178.799 134.615 182.02 136.548L183.523 134.186C180.302 132.468 177.51 130.32 174.719 127.958L172.786 129.891Z",
    fill: "#13191F"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2672,
    d: "M158.829 106.055L156.252 107.128C157.755 110.564 159.473 114 161.62 117.221L163.983 115.718C161.835 112.497 160.117 109.276 158.829 106.055Z",
    fill: "#13191F"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2126,
    d: "M165.483 117.865L163.121 119.583C165.269 122.589 167.845 125.595 170.637 128.172L172.57 126.24C169.993 123.448 167.631 120.656 165.483 117.865Z",
    fill: "#13191F"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3623,
    d: "M212.511 141.702H211.867V144.493H212.511C216.162 144.493 219.598 144.279 223.249 143.634L222.819 140.843C219.383 141.487 215.947 141.702 212.511 141.702Z",
    fill: "#13191F"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3262,
    d: "M220.028 22.9488C216.377 22.5193 212.512 22.3046 208.646 22.5193L208.861 25.3109C212.512 25.0962 216.162 25.3109 219.598 25.7404L220.028 22.9488Z",
    fill: "#13191F"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3033,
    d: "M197.696 142.775C201.347 143.634 205.212 144.278 208.863 144.493L209.078 141.701C205.427 141.487 201.776 141.057 198.341 140.198L197.696 142.775Z",
    fill: "#13191F"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_119_128506"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 425,
    height: 166,
    rx: 12,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_119_128506"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 195.313,
    height: 195.313,
    fill: "white",
    transform: "translate(114.687 -14.3135)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBonusesBgNoActive);
export default __webpack_public_path__ + "static/media/bonusesBGNoActive.595f82b30830a3859bb72fbb673a1295.svg";
export { ForwardRef as ReactComponent };